<template>
  <iframe
    style="height:100%; width:100%; text-align:center; min-height:400px; max-height:100%"
    :src="product.location_sales_report"
    frameborder="0"
    width="100%"
    height="100%"
    allowtransparency
  ></iframe>
</template>

<script>
  export default {
    props: {
      product: Object
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Common/Product/LocationSales.vue